import { createRouter, createWebHistory } from 'vue-router'
import { SOLUCIONES } from '../data/soluciones'

// Importar las vistas (las crearemos después)
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/problema',
    name: 'reto-territorial',
    component: () => import('../views/ProblemaView.vue')
  },
  // `/solucion` se retiró como página; el índice del ecosistema vive en el Inicio. La ruta se
  // conserva como redirección para no romper los enlaces ya compartidos.
  {
    path: '/solucion',
    redirect: { path: '/', hash: '#soluciones' }
  },
  // Las cuatro subpáginas de soluciones comparten una vista; cada ruta conserva su URL y nombre
  // y le pasa a SolucionDetalleView el id de la solución en src/data/soluciones.js.
  ...SOLUCIONES.map((solucion) => ({
    path: solucion.ruta,
    name: solucion.id,
    component: () => import('../views/SolucionDetalleView.vue'),
    props: { id: solucion.id }
  })),
  {
    path: '/trayectoria',
    name: 'trayectoria',
    component: () => import('../views/TrayectoriaView.vue'),
    meta: {
      descripcion: 'Entidades que ya gobiernan con Gob 24/7, los reconocimientos que ha recibido y las voces de quienes la usan: Alcaldía de Santiago de Cali y Alcaldía de Miranda.'
    }
  },
  {
    path: '/como-empezar',
    name: 'como-empezar',
    component: () => import('../views/ComoEmpezarView.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: () => import('../views/ContactoView.vue')
  },
  // Verificación interna del sistema de diseño: renderiza cada token de @theme y cada primitiva
  // gob-*. Solo existe fuera de producción y no se enlaza desde la navegación.
  ...(process.env.NODE_ENV !== 'production'
    ? [{
        path: '/styleguide',
        name: 'styleguide',
        component: () => import('../views/StyleguideView.vue')
      }]
    : []),
  // Comodín: cualquier ruta que no coincida con las anteriores. Debe ir siempre al final.
  {
    path: '/:pathMatch(.*)*',
    name: 'no-encontrado',
    component: () => import('../views/NoEncontradoView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Hacer scroll al inicio al cambiar de página
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // Anclas internas (p. ej. /#que-es): deja libre el alto del header fijo.
    if (to.hash) {
      const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      return { el: to.hash, top: 96, behavior: reducirMovimiento ? 'auto' : 'smooth' }
    }
    return { top: 0 }
  }
})

// Título de cada pestaña, tomado de la etiqueta que la ruta ya tiene en la navegación.
// Los de las soluciones salen del registro para no duplicar nombres.
const TITULOS = {
  'reto-territorial': 'El Reto Territorial',
  ...Object.fromEntries(SOLUCIONES.map((solucion) => [solucion.id, solucion.nombre])),
  trayectoria: 'Trayectoria',
  'como-empezar': '¿Cómo Empezar?',
  contacto: 'Contacto',
  'no-encontrado': 'Página no encontrada'
}

/** Crea la etiqueta si no existe: index.html no declara meta description ni Open Graph. */
function fijarMeta(atributo, nombre, contenido) {
  let etiqueta = document.head.querySelector(`meta[${atributo}="${nombre}"]`)
  if (!etiqueta) {
    etiqueta = document.createElement('meta')
    etiqueta.setAttribute(atributo, nombre)
    document.head.appendChild(etiqueta)
  }
  etiqueta.setAttribute('content', contenido)
}

router.afterEach((to) => {
  const titulo = TITULOS[to.name] ? `${TITULOS[to.name]} · Gob 24/7` : 'Gob 24/7'
  document.title = titulo
  // Solo las rutas que declaran `meta.descripcion` la publican; el resto queda sin la etiqueta.
  const descripcion = to.meta?.descripcion ?? ''
  fijarMeta('name', 'description', descripcion)
  fijarMeta('property', 'og:title', titulo)
  fijarMeta('property', 'og:description', descripcion)
})

export default router
